module.exports = __webpack_public_path__ + "img/i-digital.cf54b264.svg";